import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {Role} from "../../model/role.type";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions";
import {ApolloQueryObservable} from "apollo-angular";
import {UserService} from "../../user/user.service";
import {isUndefined} from "util";

@Component({
  selector: 'vb-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.css']
})
export class RolesListComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit, OnChanges {

  @Input()
  rolesForm: FormGroup;

  @Input()
  activeRoles: Role[] | string[];

  private roles$: ApolloQueryObservable<any>;
  public roles: Role[];

  @Output()
  selectedRolesChange: EventEmitter<Role[]> = new EventEmitter();

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder, private userService: UserService) {
    super(sessionActions, cd);
    this.rolesForm = this.fb.group({});
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.roles$ = this.userService.getRoles();
    this.addComponentData(this.roles$);
    this.addSubscription(this.roles$.subscribe(res => {
      this.roles = res.data.roles;
      this.onRolesChange();
    }));

  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.activeRoles) {
      this.onActiveRolesChange();
    }

  }


  ngAfterViewInit(): any {
    super.ngAfterViewInit();
    this.onSelectedChanged();
  }

  private onActiveRolesChange() {

    if (!this.rolesForm) {
      return;
    }

    if (!this.roles) {
      return;
    }

    if (!this.activeRoles || !this.activeRoles.length) {
      return;
    }

    let roles = [];

    if ((<Role>this.activeRoles[0]).name !== undefined) {
      roles = (<Role[]>this.activeRoles).map(role => role.name);
    } else {
      roles = this.activeRoles;
    }

    roles = roles ? roles : [];

    for (let roleKey in this.rolesForm.controls) {
      let exists = isUndefined(roles.find(r => r == roleKey)) === false;
      if (this.rolesForm.get(roleKey)) {
        this.rolesForm.get(roleKey).setValue(exists);
      } else {
        console.warn("Trying to set role '" + roleKey + "' to active, but role does not exist!");
      }
    }

    this.onSelectedChanged();

  }

  private onRolesChange() {

    let oldValues = this.rolesForm.value;

    this.rolesForm.controls = {};

    for (let r of this.roles) {
      this.rolesForm.addControl(r.name, this.fb.control(false))
    }

    this.rolesForm.patchValue(oldValues);
    this.onActiveRolesChange();

  }

  onSelectedChanged() {
    let active = [];

    for (let key in this.rolesForm.value) {
      if (this.rolesForm.value[key]) {
        active.push(key);
      }
    }

    this.selectedRolesChange.emit(active || []);
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/components/roles-list/roles-list.component.ts